require('flatpickr');

for (let el of $('.datetime-picker-custom')) {
    $(el).flatpickr({
        mode: el.hasAttribute('data-range') ? 'range' : 'single',
        enableTime: el.hasAttribute('data-time'),
        noCalendar: el.hasAttribute('data-no-calender'),
        maxDate: el.hasAttribute('min-date') ? (new Date().getFullYear()-16) + '-12-31' : '',
        minDate: el.hasAttribute('min-date') ? (new Date().getFullYear()-102) + '-1-1' : '',
        altInput: true,
    });
}
